
export const baseUrl = new URL("http://192.168.100.230:3005")

/**上传图片时的文件格式限制
 * 
 * 类型名参见：https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#accept
 * 
 * 但是格式使用数组
 */
 export const GENERAL_ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png"]